import { Route, createBrowserRouter, createRoutesFromElements, Outlet } from 'react-router-dom';
import { publicNavigationConfig } from './publicRoutes';
import { Dashboard } from '../../pages/dashboard/Dashboard';
import { Auth0ProviderWithRedirectCallback } from './ProtectedRoute';
import { PublicGlobalModals } from '../modals/PublicGlobalModals';
import { AuthenticatedGlobalModals } from '../modals/AuthenticatedGlobalModals';
import {
  devNavigationConfig,
  officialAuthenticatedNavigationConfig,
} from './authenticatedRoutes/official/officialAuthenticatedNavigationConfig';
import { employeeAuthenticatedNavigationConfig } from './authenticatedRoutes/employee/employeeAuthenticatedNavigationConfig';
import { RouteError } from './RouteError';

const authenticatedRouteElements = officialAuthenticatedNavigationConfig
  .concat(employeeAuthenticatedNavigationConfig)
  .concat(import.meta.env.VITE_REACT_APP_SHOW_DEV_ROUTES === 'true' ? devNavigationConfig : [])
  .map((route) => <Route key={route.path} path={route.path} lazy={route.lazy} />);

const publicRouteElements = publicNavigationConfig.map((route) => (
  <Route key={route.path} path={route.path} lazy={route.lazy} />
));

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        errorElement={<RouteError />}
        element={
          <>
            <PublicGlobalModals />
            <Outlet />
          </>
        }
      >
        {publicRouteElements}
      </Route>
      <Route element={<Auth0ProviderWithRedirectCallback />} errorElement={<RouteError />}>
        <Route
          path="/"
          element={
            <>
              <Dashboard />
              <AuthenticatedGlobalModals />
            </>
          }
        >
          {authenticatedRouteElements}
        </Route>
      </Route>
    </>
  )
);
